import { useEffect } from 'react';
import { useTabPaneInfo } from './TabPaneContext';
import { useTabs } from './TabsContext';

/**
 * A page calls this with its own "has unsaved changes" boolean so ITS tab
 * shows the dirty dot (LopTabBar), is confirmed-before-close (×, middle
 * click, "close others"/"close all"), and participates in the global
 * `beforeunload` guard (plan §3.6). No-ops outside a tab pane — safe to call
 * from a screen exercised without TabHost (e.g. a future unit test harness).
 */
export function useTabDirty(isDirty: boolean): void {
  const pane = useTabPaneInfo();
  const { setDirty } = useTabs();
  useEffect(() => {
    if (!pane) return;
    setDirty(pane.key, isDirty);
  }, [pane, isDirty, setDirty]);
}
